module.exports = __webpack_public_path__ + "images/category_lp/alcohol/new/assessment_achievements/6@2x_1dc012ac8658651a33c313863103bc04.png";